import { render, staticRenderFns } from "./ModalDataEdit.vue?vue&type=template&id=f287ea84&scoped=true"
import script from "./ModalDataEdit.vue?vue&type=script&lang=js"
export * from "./ModalDataEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalDataEdit.vue?vue&type=style&index=0&id=f287ea84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f287ea84",
  null
  
)

export default component.exports